import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { ListCell } from '@src/components/table-list/cells'
import { Body1 } from '@src/elements/typography/typography'

@Component
export class StatusCell extends ListCell {

  render (h: CreateElement) {
    return <div class='cell status-cell'>
      <Body1 class={this.item[this.name]}>{this.$t(`PAGE.MEMBERS.CHECKUPS.STATUS.${this.item[this.name].toUpperCase()}`)}</Body1>
    </div>
  }
}
